import React from 'react';
import { useTheme } from 'styled-components';

const WalletIcon = ({ size = 16, color = 'currentColor', ...props }) => {
    const theme = useTheme()
    return(
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.90033 2.63337V5.1667H8.90033V2.63337C8.90033 2.45337 8.74033 2.3667 8.63366 2.3667C8.60033 2.3667 8.56699 2.37337 8.53366 2.3867L3.24699 4.38003C2.89366 4.51337 2.66699 4.8467 2.66699 5.2267V5.67337C2.06033 6.1267 1.66699 6.85337 1.66699 7.67337V5.2267C1.66699 4.43337 2.15366 3.7267 2.89366 3.4467L8.18699 1.4467C8.33366 1.39337 8.48699 1.3667 8.63366 1.3667C9.30033 1.3667 9.90033 1.9067 9.90033 2.63337Z"
      fill={theme?.dark ? theme?.primaryDark : color}
    />
    <path
      d="M14.3331 9.66683V10.3335C14.3331 10.5135 14.1931 10.6602 14.0065 10.6668H13.0331C12.6798 10.6668 12.3598 10.4068 12.3331 10.0602C12.3131 9.8535 12.3931 9.66016 12.5265 9.52683C12.6465 9.40016 12.8131 9.3335 12.9931 9.3335H13.9998C14.1931 9.34016 14.3331 9.48683 14.3331 9.66683Z"
      fill={theme?.dark ? theme?.primaryDark : color}
    />
    <path
      d="M12.987 8.63317H13.667C14.0337 8.63317 14.3337 8.33317 14.3337 7.9665V7.67317C14.3337 6.29317 13.207 5.1665 11.827 5.1665H4.17366C3.60699 5.1665 3.08699 5.35317 2.66699 5.67317C2.06033 6.1265 1.66699 6.85317 1.66699 7.67317V12.1598C1.66699 13.5398 2.79366 14.6665 4.17366 14.6665H11.827C13.207 14.6665 14.3337 13.5398 14.3337 12.1598V12.0332C14.3337 11.6665 14.0337 11.3665 13.667 11.3665H13.087C12.447 11.3665 11.8337 10.9732 11.667 10.3532C11.527 9.8465 11.6937 9.35984 12.027 9.03317C12.2737 8.77984 12.6137 8.63317 12.987 8.63317ZM9.33366 8.49984H4.66699C4.39366 8.49984 4.16699 8.27317 4.16699 7.99984C4.16699 7.7265 4.39366 7.49984 4.66699 7.49984H9.33366C9.60699 7.49984 9.83366 7.7265 9.83366 7.99984C9.83366 8.27317 9.60699 8.49984 9.33366 8.49984Z"
      fill={theme?.dark ? theme?.primaryDark : color}
    />
  </svg>
)};

export default WalletIcon;
